export const reCaptchaActions = {
    login: 'LOGIN',
    createAccount: 'CREATE_ACCOUNT',
    contact: 'CONTACT',
    createInstantPayment: 'CREATE_INSTANT_PAYMENT',
    createDeferredPayment: 'CREATE_DEFERRED_PAYMENT',
    changeDeferredPayment: 'CHANGE_DEFERRED_PAYMENT',
    grantOrderAccess: 'GRANT_ORDER_ACCESS',
};
